import { cn } from '@rhpc/ui';

export const ROBUST_MARK_SRC = '/robust-mark.png';
export const ROBUST_WORDMARK_SRC = '/robust-wordmark.png';

interface BrandMarkProps {
  compact?: boolean;
  variant?: 'nav' | 'auth';
  className?: string;
}

export function BrandMark({ compact = false, variant = 'nav', className }: BrandMarkProps) {
  if (variant === 'auth') {
    return (
      <div className={cn('flex flex-col items-center', className)}>
        <img
          src={ROBUST_WORDMARK_SRC}
          alt="Robust"
          width={178}
          height={62}
          className="h-8 w-auto"
        />
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-2.5', compact && 'justify-center', className)}>
      <img
        src={ROBUST_MARK_SRC}
        alt={compact ? 'RHPC Claim System' : ''}
        width={32}
        height={32}
        className="h-8 w-8 shrink-0 rounded-md"
      />
      {!compact && (
        <div className="flex min-w-0 flex-col leading-[1.15]">
          <span className="text-[15px] font-bold tracking-tight text-text">RHPC</span>
          <span className="text-[12px] text-text-3">Claim System</span>
        </div>
      )}
    </div>
  );
}

interface AuthBrandProps {
  title?: string;
  subtitle?: string;
  subtitleClassName?: string;
}

export function AuthBrand({ title, subtitle, subtitleClassName }: AuthBrandProps) {
  return (
    <div className="mb-6 flex flex-col items-center text-center">
      <BrandMark variant="auth" />
      {title ? <h1 className="mt-4 text-h1 text-text">{title}</h1> : null}
      {subtitle ? (
        <p className={cn('mt-1.5 text-sm text-text-3', subtitleClassName)}>{subtitle}</p>
      ) : null}
    </div>
  );
}
